export default [
  {
    path: 'recommend',
    name: 'PlanetRecommend',
    meta: {
      IndexHeader: true,
      itemIndex: 3
    },
    component: () =>
    import(/* webpackChunkName: "SubCommon" */ '@/components/planet/recommend/index')
  },
  {
    path: 'topic',
    name: 'PlanetTopic',
    meta: {
      IndexHeader: true,
      itemIndex: 2
    },
    component: () =>
    import(/* webpackChunkName: "SubCommon" */ '@/components/planet/topic/index')
  },
  {
    path: 'personal',
    name: 'PlanetPersonalCenter',
    meta: {
      IndexHeader: true,
      itemIndex: 3
    },
    component: () =>
    import(/* webpackChunkName: "SubCommon" */ '@/components/planet/personal-center/index')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/sub-task/planet-sub.js